var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.partnerList},_vm._l((_vm.paymenList),function(item){return _c(item,{key:item,tag:"component"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }